// PARAQTA — «Шамнан шырақ» басты беті (30.09.2026, founder бекітті).
// Қараңғы бет, жалғыз шам: Алтынсарин сөзі шамның ұшқындарынан құралады, шам бетпен
// бірге жүріп жанып қысқарады, мәтін шам жарығына жақындағанда айқындалады.
// Мокап: scratchpad/pq_wow/v2.html (артефакт Uc2uwzd2r9kN5AbJFcLd9B).
//
// ❗ЖЫЛДАМДЫҚ ЕРЕЖЕЛЕРІ (телефонда қатпас үшін):
//  - қараңғылық пен жарық = кішкентай CSS қабаттар (512/256px), тек transform-пен
//    жылжиды — әр кадрда толық экран САЛЫНБАЙДЫ;
//  - шам = кішкентай canvas; ұшқын canvas-ы тек кіріспеде, сосын өшіріледі;
//  - сенсорлы экранда blur жоқ; телефонда 3D бөлме — статикалық сурет;
//  - `html{overflow-x:clip}` ҚОЛДАНБА — мобильді Chrome бетті қиып көрсетеді.
// Барлық кластар `sq-` префиксімен (қолданбаның стильдерімен қақтығыспау үшін).

const INTRO_KEY = 'pq-intro-v1';
const THEME_KEY = 'pq-landing-theme';

const nf = (n) => String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const BOOK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5.5c3-1.3 6-1.3 9 .5 3-1.8 6-1.8 9-.5V19c-3-1.3-6-1.3-9 .5-3-1.8-6-1.8-9-.5z"></path><path d="M12 6v13.5"></path></svg>';

const CSS = `
.sq{--bg:#0A0806;--ink:#F2E9D8;--ink2:#C2B59F;--muted:#8E826F;--gold:#E3B45E;--gold2:#F6D493;--line:rgba(227,180,94,.16);
  --btn:#E3B45E;--btnInk:#140E08;--glowText:0 0 42px rgba(227,180,94,.35);--shade:10,8,6;--a1:.38;--a2:.70;--warmA:.14;
  --serif:'PT Serif',Georgia,serif;--sans:'PT Sans',system-ui,sans-serif;--mono:'IBM Plex Mono',ui-monospace,monospace;
  position:relative;min-height:100vh;background:var(--bg);color:var(--ink);font:400 17px/1.55 var(--sans);-webkit-font-smoothing:antialiased;overflow-x:clip}
.sq[data-sq-theme="day"]{--bg:#EEE5D3;--ink:#1F160E;--ink2:#4E4233;--muted:#6B5E4B;--gold:#8A5A1E;--gold2:#6B4312;--line:rgba(90,60,20,.18);
  --btn:#1F160E;--btnInk:#F5EDDD;--glowText:none;--shade:238,229,211;--a1:.28;--a2:.56;--warmA:.16}
.sq *{box-sizing:border-box}
.sq a{color:inherit}
.sq a:focus-visible,.sq button:focus-visible{outline:2px solid var(--gold);outline-offset:4px}
.sq button{font-family:inherit}
.sq-lights{position:fixed;inset:0;z-index:5;overflow:hidden;pointer-events:none;contain:strict}
.sq-vig,.sq-warm,.sq-blk,.sq-cd,.sq-fx{position:absolute;left:0;top:0;pointer-events:none}
.sq-vig{width:512px;height:512px;transform-origin:50% 50%;will-change:transform;background:radial-gradient(circle closest-side,rgba(var(--shade),0) 26%,rgba(var(--shade),var(--a1)) 68%,rgba(var(--shade),var(--a2)) 100%)}
.sq-warm{width:256px;height:256px;transform-origin:50% 50%;will-change:transform,opacity;background:radial-gradient(circle closest-side,rgba(255,160,70,var(--warmA)),rgba(255,160,70,0));animation:sq-wflick 3.4s ease-in-out infinite}
@keyframes sq-wflick{0%,100%{opacity:1}23%{opacity:.86}41%{opacity:.97}67%{opacity:.83}84%{opacity:.95}}
.sq-blk{right:0;bottom:0;background:var(--bg);will-change:opacity}
.sq-cd{will-change:transform}
.sq-grain{position:fixed;inset:0;z-index:6;pointer-events:none;opacity:.055;background-size:180px 180px}
.sq-nav{position:fixed;top:0;left:0;right:0;z-index:10;display:flex;align-items:center;justify-content:space-between;padding:22px clamp(18px,4vw,56px);opacity:0;transition:opacity 1.2s ease}
.sq.sq-nav-on .sq-nav{opacity:1}
.sq-nav::before{content:"";position:absolute;inset:0 0 -40px 0;z-index:-1;pointer-events:none;background:linear-gradient(var(--bg) 35%,transparent)}
.sq-logo{font:700 16px var(--serif);letter-spacing:.34em;text-decoration:none;color:var(--ink)}
.sq-nav-r{display:flex;align-items:center;gap:clamp(12px,2.2vw,30px);font-size:15px}
.sq-link{background:none;border:0;padding:0;cursor:pointer;color:var(--ink2);font:inherit}
.sq-link:hover{color:var(--ink)}
.sq-tg{display:inline-flex;align-items:center;gap:8px;background:none;border:1px solid var(--line);color:var(--ink2);border-radius:999px;min-height:40px;padding:0 14px;font:500 11px var(--mono);letter-spacing:.16em;text-transform:uppercase;cursor:pointer}
.sq-tg svg{width:15px;height:15px}
.sq-enter{display:inline-flex;align-items:center;min-height:42px;padding:0 20px;border-radius:999px;border:0;background:var(--btn);color:var(--btnInk);font:700 15px var(--sans);cursor:pointer}
.sq-wrap{width:min(1280px,100%);margin:0 auto;padding:0 clamp(20px,6vw,88px)}
.sq-hero{position:relative;min-height:100svh;display:flex;align-items:center;padding:110px 0 90px}
.sq-hero-in{width:min(920px,64vw)}
.sq-q{margin:0;font:italic 400 clamp(25px,2.9vw,44px)/1.22 var(--serif);color:var(--gold)}
.sq-ql{display:block;width:fit-content;white-space:nowrap;opacity:0;transition:opacity 1s ease}
.sq.sq-q-on .sq-ql{opacity:1}
.sq-by{margin-top:14px;font:500 11.5px var(--mono);letter-spacing:.24em;text-transform:uppercase;color:var(--muted)}
.sq-h1{margin:clamp(34px,5vh,56px) 0 0;font:700 clamp(42px,5.1vw,88px)/.98 var(--serif);letter-spacing:-.022em;text-wrap:balance;color:var(--ink)}
.sq-h1 span{display:block}
.sq-h1 em{font-weight:400;font-style:italic;color:var(--gold2);text-shadow:var(--glowText)}
.sq-sub{margin:28px 0 0;max-width:40ch;font-size:clamp(17px,1.35vw,20px);color:var(--ink2)}
.sq-ctas{position:relative;z-index:7;display:flex;flex-wrap:wrap;align-items:center;gap:14px;margin-top:36px}
.sq-btn{position:relative;display:inline-flex;align-items:center;gap:12px;min-height:58px;padding:0 30px;border:0;border-radius:999px;background:var(--btn);color:var(--btnInk);font:700 16px var(--sans);cursor:pointer;transition:transform .35s cubic-bezier(.2,.7,.2,1),box-shadow .35s}
.sq-btn:hover{transform:translateY(-2px);box-shadow:0 18px 44px -14px rgba(227,180,94,.55)}
.sq-btn i{font-style:normal;transition:transform .35s}
.sq-btn:hover i{transform:translateX(5px)}
.sq-ghost{display:inline-flex;align-items:center;gap:10px;min-height:58px;padding:0 24px;border-radius:999px;border:1px solid var(--line);background:transparent;color:var(--ink);font:700 16px var(--sans);cursor:pointer;transition:border-color .3s}
.sq-ghost:hover{border-color:var(--gold)}
.sq-ghost svg{width:19px;height:19px;color:var(--gold)}
.sq-fine{margin:16px 0 0;font-size:13.5px;color:var(--muted)}
.sq-hr{opacity:0;transform:translateY(26px);filter:blur(8px);transition:opacity 1.1s ease,transform 1.3s cubic-bezier(.2,.7,.2,1),filter 1.1s ease;transition-delay:var(--d,0s)}
.sq.sq-h-on .sq-hr{opacity:1;transform:none;filter:none}
.sq-cue{position:absolute;left:50%;bottom:26px;translate:-50% 0;display:flex;flex-direction:column;align-items:center;gap:10px;font:500 10.5px var(--mono);letter-spacing:.3em;text-transform:uppercase;color:var(--muted)}
.sq-cue b{display:block;width:1px;height:48px;background:linear-gradient(var(--line),transparent);position:relative;overflow:hidden}
.sq-cue b::after{content:"";position:absolute;left:0;top:0;width:1px;height:19px;background:var(--gold);transform:translateY(-100%);animation:sq-drip 2.4s ease-in infinite}
@keyframes sq-drip{to{transform:translateY(260%)}}
.sq-event:not(:empty){margin:0 0 26px}
.sq-sec{position:relative;padding:clamp(110px,16vh,190px) 0}
.sq-h2{margin:18px 0 0;font:700 clamp(38px,5vw,78px)/1.02 var(--serif);letter-spacing:-.018em;text-wrap:balance;color:var(--ink)}
.sq-lede{margin:24px 0 0;max-width:34ch;font-size:clamp(18px,1.55vw,22px);color:var(--ink2)}
.sq-rv{opacity:0;transform:translateY(34px);filter:blur(10px);transition:opacity 1.2s ease,transform 1.4s cubic-bezier(.2,.7,.2,1),filter 1.2s ease;transition-delay:var(--d,0s)}
.sq-rv.sq-in{opacity:1;transform:none;filter:none}
.sq-show{display:grid;grid-template-columns:minmax(0,1.25fr) minmax(0,1fr);gap:clamp(24px,5vw,80px)}
.sq-step{min-height:78vh;padding:16vh 0 0;opacity:.26;transition:opacity .7s ease}
.sq-step:first-child{padding-top:6vh}
.sq-step.sq-act{opacity:1}
.sq-step .sq-n{font:500 13px var(--mono);letter-spacing:.2em;color:var(--gold)}
.sq-step h3{margin:14px 0 20px;font:700 clamp(52px,6.2vw,112px)/.9 var(--serif);letter-spacing:-.035em;color:var(--ink)}
.sq-step h3 i{font-style:normal;color:var(--gold)}
.sq-step p{margin:0;max-width:31ch;font-size:clamp(18px,1.6vw,23px);color:var(--ink2)}
.sq-show-phone{position:relative}
.sq-phone{position:sticky;top:max(84px,calc(50vh - 300px));margin:0 auto;width:290px;height:600px;border-radius:46px;background:#0E0A07;border:1px solid rgba(227,180,94,.28);box-shadow:0 70px 140px -50px rgba(0,0,0,.9),inset 0 0 0 7px #1A130D,0 0 90px -20px rgba(227,170,80,.28);overflow:hidden}
@media (min-width:900px) and (max-height:780px){.sq-show-phone .sq-phone{zoom:.8}}
.sq-scr{position:absolute;inset:7px;border-radius:40px;padding:34px 22px 24px;display:flex;flex-direction:column;align-items:center;opacity:0;transform:translateY(18px) scale(.98);transition:opacity .6s ease,transform .8s cubic-bezier(.2,.7,.2,1);background:radial-gradient(ellipse 90% 60% at 50% 38%,rgba(227,170,80,.10),transparent 70%),#110C08;color:#F2E9D8;font-family:var(--sans)}
.sq-phone[data-on="0"] .sq-s0,.sq-phone[data-on="1"] .sq-s1,.sq-phone[data-on="2"] .sq-s2{opacity:1;transform:none}
.sq-phone:not([data-on="0"]) .sq-s0 *,.sq-phone:not([data-on="1"]) .sq-s1 *,.sq-phone:not([data-on="2"]) .sq-s2 *,.sq-off *{animation-play-state:paused !important}
.sq-bookrow{align-self:stretch;display:flex;gap:12px;align-items:center}
.sq-cov{width:34px;height:48px;border-radius:4px;background:linear-gradient(135deg,#7A4527,#3A2114);box-shadow:0 6px 14px -6px #000;flex:none}
.sq-bookrow b{display:block;font:700 15px var(--serif)}
.sq-bookrow span{display:block;color:#9C8F7B;font-size:12px}
.sq-ring{position:relative;width:210px;height:210px;margin:38px 0 26px}
.sq-ring svg{position:absolute;inset:0;transform:rotate(-90deg)}
.sq-rt{fill:none;stroke:rgba(227,180,94,.14);stroke-width:4}
.sq-rp{fill:none;stroke:#E3B45E;stroke-width:4;stroke-linecap:round;stroke-dasharray:565.5;stroke-dashoffset:var(--off,210);transition:stroke-dashoffset 1s linear}
.sq-mini{position:absolute;left:50%;top:34px;translate:-50% 0;display:flex;flex-direction:column;align-items:center}
.sq-mini::before{content:"";position:absolute;left:50%;top:-22px;width:72px;height:72px;translate:-50% 0;border-radius:50%;background:radial-gradient(circle,rgba(255,190,90,.42),transparent 65%)}
.sq-mf{position:relative;display:block;width:14px;height:24px;border-radius:50% 50% 50% 50%/62% 62% 38% 38%;background:radial-gradient(ellipse 50% 62% at 50% 72%,#FFFDF3 0%,#FFE9B0 30%,#F2A845 65%,rgba(232,130,40,0) 82%);transform-origin:50% 90%;animation:sq-mflick 2.6s ease-in-out infinite}
.sq-mw{position:relative;display:block;width:22px;height:30px;margin-top:2px;border-radius:4px 4px 3px 3px;background:linear-gradient(90deg,#9C7A4E,#EEDDBC 45%,#C9AC7E 75%,#8A6A40)}
@keyframes sq-mflick{0%,100%{transform:scale(1)}30%{transform:scale(.94,1.06) rotate(-2deg)}60%{transform:scale(1.05,.96) rotate(1.5deg)}}
.sq-tm{position:absolute;left:0;right:0;top:108px;text-align:center;font:500 40px var(--mono);font-variant-numeric:tabular-nums}
.sq-tl{position:absolute;left:0;right:0;top:158px;text-align:center;font-size:12px;color:#9C8F7B}
.sq-pbtn{align-self:stretch;min-height:46px;border-radius:999px;display:grid;place-items:center;font-weight:700;font-size:14px;margin-top:10px}
.sq-pbtn.sq-out{border:1px solid rgba(227,180,94,.35)}
.sq-pbtn.sq-txt{color:#9C8F7B;font-weight:400;min-height:36px}
.sq-pbtn.sq-gold{background:#E3B45E;color:#140E08;margin-top:auto}
.sq-ph-t{margin-top:28px;font:700 24px var(--serif);text-align:center}
.sq-ph-s{margin-top:8px;font-size:13px;color:#9C8F7B;text-align:center}
.sq-ph-s b{color:#F2E9D8}
.sq-pgbox{margin-top:28px;width:170px;height:84px;border-radius:18px;border:1.5px solid #7FC47E;display:flex;align-items:center;justify-content:center;gap:4px;font:700 46px var(--serif);font-variant-numeric:tabular-nums}
.sq-caret{display:block;width:2px;height:40px;background:#E3B45E;animation:sq-blink 1s steps(1) infinite}
@keyframes sq-blink{50%{opacity:0}}
.sq-calc{margin-top:18px;font-size:13.5px;color:#C2B59F;text-align:center}
.sq-calc b{color:#F6D493}
.sq-hint{margin-top:14px;padding:10px 14px;border-radius:12px;background:rgba(227,180,94,.08);border:1px solid rgba(227,180,94,.18);font-size:12px;line-height:1.5;color:#C2B59F;text-align:center}
.sq-bigflame{position:relative;margin-top:30px;width:62px;height:62px;color:#F2A845}
.sq-bigflame::before{content:"";position:absolute;inset:-26px;border-radius:50%;background:radial-gradient(circle,rgba(242,168,69,.45),transparent 62%)}
.sq-bigflame svg{position:relative;width:100%;height:100%;display:block}
.sq-streak{text-align:center;margin-top:4px}
.sq-streak b{display:block;font:700 72px/1 var(--serif)}
.sq-streak span{font:500 11px var(--mono);letter-spacing:.2em;text-transform:uppercase;color:#9C8F7B}
.sq-week{margin-top:26px;align-self:stretch;display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:4px;text-align:center;font:500 10px var(--mono);color:#9C8F7B}
.sq-week i{position:relative;display:block;margin:0 auto 6px;width:26px;height:26px;border-radius:50%;border:1px solid rgba(227,180,94,.25)}
.sq-week .sq-on i{background:radial-gradient(circle at 50% 60%,#F6D493,#E3B45E 60%);border-color:#E3B45E}
.sq-week .sq-today i{background:radial-gradient(circle at 50% 60%,#FFF3D6,#E3B45E 60%);border-color:#F6D493}
.sq-week .sq-today i::after{content:"";position:absolute;inset:-1px;border-radius:50%;border:1px solid rgba(227,180,94,.8);animation:sq-ring 2s ease-out infinite}
@keyframes sq-ring{0%{transform:scale(1);opacity:.9}80%,100%{transform:scale(1.7);opacity:0}}
.sq-note{margin-top:auto;align-self:stretch;padding:12px 14px;border-radius:14px;background:rgba(127,196,126,.08);border:1px solid rgba(127,196,126,.25);font-size:12.5px;color:#C2B59F;line-height:1.45}
.sq-note b{color:#F2E9D8}
.sq-pslot{display:none}
.sq-together{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:clamp(32px,6vw,96px);align-items:center}
.sq-together .sq-lede{margin:22px 0 0}
.sq-live{display:inline-flex;align-items:center;gap:10px;font:500 11.5px var(--mono);letter-spacing:.18em;text-transform:uppercase;color:var(--gold);border:1px solid var(--line);border-radius:999px;padding:8px 14px}
.sq-dot{position:relative;width:7px;height:7px;border-radius:50%;background:#7FC47E}
.sq-dot::after{content:"";position:absolute;inset:0;border-radius:50%;border:1px solid rgba(127,196,126,.8);animation:sq-ring2 2.2s ease-out infinite}
@keyframes sq-ring2{0%{transform:scale(1);opacity:.9}80%,100%{transform:scale(3.2);opacity:0}}
.sq-minis{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:18px;margin-top:36px;padding-top:26px;border-top:1px solid var(--line)}
.sq-minis b{display:block;font:700 clamp(24px,2.4vw,36px)/1 var(--serif);font-variant-numeric:tabular-nums lining-nums;color:var(--ink)}
.sq-minis span{display:block;margin-top:8px;font:500 10.5px var(--mono);letter-spacing:.2em;text-transform:uppercase;color:var(--muted)}
.sq-room{position:relative;margin:0;justify-self:center;width:100%;max-width:520px;overflow:hidden}
.sq-room video{display:block;width:100%;height:auto;background:var(--bg)}
.sq-room::after{content:"";position:absolute;inset:-1px;pointer-events:none;background:radial-gradient(ellipse 50% 50% at 50% 50%,rgba(var(--shade),0) 56%,var(--bg) 99%)}
.sq-fq{margin:0 auto;max-width:24ch;text-align:center;font:400 clamp(30px,4.3vw,66px)/1.16 var(--serif);letter-spacing:-.012em;color:var(--ink)}
.sq-fq .sq-w{opacity:.14;transition:opacity .45s ease,color .45s ease}
.sq-fq .sq-w.sq-won{opacity:1}
.sq-fq .sq-w.sq-hot{color:var(--gold2)}
.sq-fq-by{margin-top:40px;text-align:center;font:500 12px var(--mono);letter-spacing:.24em;text-transform:uppercase;color:var(--muted)}
.sq-fq-by b{color:var(--ink);font-weight:500}
.sq-big{text-align:center}
.sq-big blockquote{margin:0 auto;max-width:16ch;font:italic 400 clamp(44px,7.4vw,124px)/1.02 var(--serif);letter-spacing:-.02em;text-wrap:balance;color:var(--ink)}
.sq-big blockquote em{color:var(--gold2);text-shadow:var(--glowText)}
.sq-big cite{display:block;margin-top:40px;font:500 12px var(--mono);font-style:normal;letter-spacing:.26em;text-transform:uppercase;color:var(--gold)}
.sq-final{text-align:center;padding-bottom:clamp(200px,28vh,280px)}
.sq-final .sq-h2{font-size:clamp(56px,9vw,150px);line-height:.95}
.sq-final .sq-lede{margin:28px auto 0;max-width:36ch}
.sq-final .sq-ctas{justify-content:center}
.sq-foot{position:relative;display:flex;justify-content:space-between;flex-wrap:wrap;gap:10px;padding:26px clamp(20px,6vw,88px) 120px;border-top:1px solid var(--line);font-size:14px;color:var(--muted)}
.sq-foot a{text-decoration:none}
.sq-foot a:hover,.sq-foot button:hover{color:var(--ink)}
.sq-foot button{background:none;border:0;padding:0;color:inherit;font:inherit;cursor:pointer}
.sq-replay{text-decoration:underline;text-underline-offset:3px}
@media (max-width:899px){
  .sq-nav-r .sq-lib{display:none}
  .sq-hero{align-items:flex-start;padding:84px 0 170px;text-align:center}
  .sq-hero-in{width:100%}
  .sq-q{font-size:25px}
  .sq-ql{margin-inline:auto}
  .sq-by{margin-top:10px}
  .sq-h1{margin-top:22px;font-size:clamp(34px,9.6vw,44px)}
  .sq-sub{margin:16px auto 0;font-size:16px}
  .sq-ctas{margin-top:22px;gap:10px;justify-content:center}
  .sq-hero .sq-btn{min-height:54px;width:100%;justify-content:center}
  .sq-hero .sq-ghost{min-height:48px;border:0;padding:0 10px;font-size:15px}
  .sq-fine{margin-top:8px}
  .sq-cue{display:none}
  .sq-show{grid-template-columns:minmax(0,1fr)}
  .sq-show-phone{display:none}
  .sq-step{min-height:0;padding:60px 0 0;opacity:1}
  .sq-step:first-child{padding-top:0}
  .sq-pslot{display:block;width:290px;height:600px;margin:26px auto -104px;transform:scale(.82);transform-origin:top center}
  .sq-pslot .sq-phone{position:relative;top:0}
  .sq-together{grid-template-columns:minmax(0,1fr);gap:28px}
  .sq-room{max-width:420px}
}
@media (hover:none){
  .sq-hr,.sq-rv{filter:none;transition:opacity 1s ease,transform 1.2s cubic-bezier(.2,.7,.2,1);transition-delay:var(--d,0s)}
  .sq-h1 em{text-shadow:none}
  .sq-grain{display:none}
}
@media (prefers-reduced-motion:reduce){
  .sq-hr,.sq-rv,.sq-ql{transition:none}
  .sq-cue b::after,.sq-warm,.sq-dot::after,.sq-week .sq-today i::after,.sq-mf,.sq-caret{animation:none}
}`;

function phoneHTML(id) {
  return `<div class="sq-phone"${id ? ` id="${id}"` : ''} data-on="0">
  <div class="sq-scr sq-s0">
    <div class="sq-bookrow"><div class="sq-cov"></div><div><b>Қара сөздер</b><span>Абай · 32-беттен</span></div></div>
    <div class="sq-ring">
      <svg viewBox="0 0 200 200"><circle class="sq-rt" cx="100" cy="100" r="90"></circle><circle class="sq-rp" cx="100" cy="100" r="90"></circle></svg>
      <div class="sq-mini"><i class="sq-mf"></i><i class="sq-mw"></i></div>
      <div class="sq-tm" data-sq-timer>18:42</div>
      <div class="sq-tl">шам жанып тұр</div>
    </div>
    <div class="sq-pbtn sq-out">Шамды қалқалау</div>
    <div class="sq-pbtn sq-txt">Шамды өшір</div>
  </div>
  <div class="sq-scr sq-s1">
    <div class="sq-ph-t">Қай бетке жеттің?</div>
    <div class="sq-ph-s">«Қара сөздер» — <b>32-беттен</b> бастадың</div>
    <div class="sq-pgbox"><span data-sq-pages>49</span><i class="sq-caret"></i></div>
    <div class="sq-calc">32-беттен → 49-бетке · <b>17 бет</b> оқыдың</div>
    <div class="sq-hint">25 минут оқыдың ≈ 17 бет<br>сенің қарқының: 0,7 бет/мин</div>
    <div class="sq-pbtn sq-gold">Сақтау</div>
  </div>
  <div class="sq-scr sq-s2">
    <div class="sq-bigflame"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5c1.2 3.4 5.2 5.4 5.2 10.6a5.2 5.2 0 0 1-10.4 0c0-2.5 1.3-3.9 2.5-5 0 2.3 1.1 3.6 2.4 3.6 0-3.5-1.1-5.9.3-9.2z"></path></svg></div>
    <div class="sq-streak"><b>12</b><span>күн қатарынан</span></div>
    <div class="sq-week"><div class="sq-on"><i></i>Дс</div><div class="sq-on"><i></i>Сс</div><div class="sq-on"><i></i>Ср</div><div class="sq-on"><i></i>Бс</div><div class="sq-on"><i></i>Жм</div><div class="sq-on"><i></i>Сн</div><div class="sq-today"><i></i>Жс</div></div>
    <div class="sq-note"><b>Бүгінгі шам жанды.</b> Ертең дәл осы уақытта еске саламыз.</div>
  </div>
</div>`;
}

export function renderShyraqLanding(stats) {
  const s = stats || {};
  let theme = 'night';
  try { if (localStorage.getItem(THEME_KEY) === 'day') theme = 'day'; } catch (_) {}
  const cta = (label) => `<button type="button" class="sq-btn" data-flare data-action="show-login">${label} <i>→</i></button>`;
  const lib = `<button type="button" class="sq-ghost" data-action="enter-guest-target" data-target="catalog">${BOOK_ICON}Тегін кітаптар</button>`;
  return `<style>${CSS}</style>
<div class="sq" data-sq-theme="${theme}">
  <div class="sq-lights" aria-hidden="true"><div class="sq-vig"></div><div class="sq-warm"></div><div class="sq-blk"></div><canvas class="sq-cd"></canvas><canvas class="sq-fx"></canvas></div>
  <div class="sq-grain" aria-hidden="true"></div>
  <header class="sq-nav">
    <span class="sq-logo">PARAQTA</span>
    <div class="sq-nav-r">
      <button type="button" class="sq-link sq-lib" data-action="enter-guest-target" data-target="catalog">Кітапхана</button>
      <button type="button" class="sq-tg" data-sq-theme-toggle aria-label="Күндізгі немесе түнгі көрініс"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"></path></svg><span data-sq-theme-label>${theme === 'day' ? 'Түнде' : 'Күндіз'}</span></button>
      <button type="button" class="sq-enter" data-action="show-login">Кіру</button>
    </div>
  </header>

  <section class="sq-hero" data-light="1.2">
    <div class="sq-wrap">
      <div class="sq-hero-in">
        <div class="sq-event" data-event-slot></div>
        <p class="sq-q" data-sq-q><span class="sq-ql">«Оқысаңыз, балалар!</span><span class="sq-ql">Шамнан шырақ жағылар…»</span></p>
        <div class="sq-by sq-hr">— Ыбырай Алтынсарин</div>
        <h1 class="sq-h1"><span class="sq-hr" style="--d:.15s">Кітап оқитын уақ —</span><span class="sq-hr" style="--d:.3s"><em>өмірдің ең бір сәулелі сәттері.</em></span></h1>
        <p class="sq-sub sq-hr" style="--d:.55s">PARAQTA — сол сәттерді күнделікті әдетке айналдыратын орын.</p>
        <div class="sq-ctas sq-hr" style="--d:.75s">${cta('Оқуды бастау')}${lib}</div>
        <p class="sq-fine sq-hr" style="--d:.9s">Тегін · 1 минутта · картасыз</p>
      </div>
    </div>
    <div class="sq-cue sq-hr" style="--d:1.4s" aria-hidden="true">төмен<b></b></div>
  </section>

  <section class="sq-sec" data-light="1.15" style="padding-top:0">
    <div class="sq-wrap"><div class="sq-show">
      <div class="sq-show-steps">
        <article class="sq-step"><span class="sq-n">01</span><h3>Шамды жақ<i>.</i></h3><p>Бір шам — 25 минут. Кітабыңды аш та, қалғанын ұмыт.</p><div class="sq-pslot" data-screen="0"></div></article>
        <article class="sq-step"><span class="sq-n">02</span><h3>Оқы<i>.</i></h3><p>Өз кітабың болсын, не мұндағы тегін кітаптардың бірі. Шам сөнгенде қай бетке жеткеніңді айтасың — қалғанын өзіміз санаймыз.</p><div class="sq-pslot" data-screen="1"></div></article>
        <article class="sq-step"><span class="sq-n">03</span><h3>Ертең тағы<i>.</i></h3><p>Күн сайын жанған шам — сенің серияң. Ертең дәл осы уақытта өзіміз еске саламыз.</p><div class="sq-pslot" data-screen="2"></div></article>
      </div>
      <div class="sq-show-phone" aria-hidden="true">${phoneHTML('sqPhone')}</div>
    </div></div>
  </section>

  <section class="sq-sec" data-light="1.1" style="padding-top:0">
    <div class="sq-wrap sq-together">
      <div>
        <div class="sq-live sq-rv"><span class="sq-dot"></span><span data-sq-live>PARAQTA-да оқып жатырмыз</span></div>
        <h2 class="sq-h2 sq-rv" style="--d:.1s">Жалғыз оқымайсың.</h2>
        <p class="sq-lede sq-rv" style="--d:.2s">«Түнгі дүкен» — ортақ оқу бөлмесі. Әр шам — бір оқырман. Досың шамын жақса, сен де білесің.</p>
        <div class="sq-minis sq-rv" style="--d:.3s">
          <div><b data-sq-count="${Number(s.users) || 0}">${nf(s.users)}</b><span>оқырман</span></div>
          <div><b data-sq-count="${Number(s.total_pages) || 0}">${nf(s.total_pages)}</b><span>оқылған бет</span></div>
          <div><b data-sq-count="${Number(s.finished) || 0}">${nf(s.finished)}</b><span>аяқталған кітап</span></div>
        </div>
      </div>
      <figure class="sq-room sq-rv" style="--d:.15s"><video muted playsinline loop preload="none" poster="/landing/room.jpg" width="580" height="724" aria-label="«Түнгі дүкен» 3D бөлмесі: кітап сөрелері арасында шамдарын жағып оқып отырған Шырақтар"><source src="/landing/room.mp4" type="video/mp4"></video></figure>
    </div>
  </section>

  <section class="sq-sec" data-light="1.1">
    <div class="sq-wrap">
      <p class="sq-fq" data-sq-words>«Тындырымды тұлғалардың ортақ олжасы – оқу. PARAQTA – "өмір" атты кітабыңның әр парағына мән бітіретін құрал.»</p>
      <div class="sq-fq-by sq-rv">— <b>Ердәулет Аянұлы</b>, негізін қалаушы</div>
    </div>
  </section>

  <section class="sq-sec sq-big" data-light="1.75">
    <div class="sq-wrap">
      <blockquote class="sq-rv">«Қазақ үшін шам қылған <em>жүрек майын</em>»</blockquote>
      <cite class="sq-rv" style="--d:.2s">— Сұлтанмахмұт Торайғыров</cite>
    </div>
  </section>

  <section class="sq-sec sq-final" data-light="2.3" style="padding-top:0">
    <div class="sq-wrap">
      <h2 class="sq-h2 sq-rv">Шамыңды бүгін жақ.</h2>
      <p class="sq-lede sq-rv" style="--d:.12s">Бір бет те жетеді. Ертең — тағы бір бет.</p>
      <div class="sq-ctas sq-rv" style="--d:.24s">${cta('Оқуды бастау')}</div>
      <p class="sq-fine sq-rv" style="--d:.32s">Тегін · 1 минутта · картасыз</p>
    </div>
  </section>
  <footer class="sq-foot">
    <span>PARAQTA © 2026</span>
    <span><button type="button" data-action="show-login">Жан дос</button> · <a href="https://t.me/paraqta_oqy" target="_blank" rel="noopener">Telegram арна</a> · <button type="button" class="sq-replay" data-sq-replay>Кіріспені қайта көру</button></span>
  </footer>
</div>`;
}

// Беттің қозғалысын іске қосады. Бет жасырылса (кіру/қонақ режимі) — цикл тоқтайды.
export function mountShyraqLanding(page) {
  const root = page && page.querySelector('.sq');
  if (!root) return;
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => Array.prototype.slice.call(root.querySelectorAll(sel));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touch = matchMedia('(hover: none)').matches;
  const cores = navigator.hardwareConcurrency || 4;
  const offs = [];
  const on = (t, ev, fn, opt) => { t.addEventListener(ev, fn, opt); offs.push(() => t.removeEventListener(ev, fn, opt)); };

  // ── тақырып (тек осы бетке) ──
  const themeLabel = $('[data-sq-theme-label]');
  const isDay = () => root.getAttribute('data-sq-theme') === 'day';
  on($('[data-sq-theme-toggle]'), 'click', () => {
    const t = isDay() ? 'night' : 'day';
    root.setAttribute('data-sq-theme', t);
    if (themeLabel) themeLabel.textContent = t === 'day' ? 'Түнде' : 'Күндіз';
    try { localStorage.setItem(THEME_KEY, t); } catch (_) {}
  });

  // ── түйіршік (бір рет салынатын статикалық қабат) ──
  if (!touch) {
    const c = document.createElement('canvas'); c.width = c.height = 180;
    const g = c.getContext('2d'); const d = g.createImageData(180, 180);
    for (let i = 0; i < d.data.length; i += 4) { const v = Math.random() * 255 | 0; d.data[i] = d.data[i + 1] = d.data[i + 2] = v; d.data[i + 3] = 255; }
    g.putImageData(d, 0, 0); $('.sq-grain').style.backgroundImage = 'url(' + c.toDataURL() + ')';
  }

  const clamp = (v, a = 0, b = 1) => (v < a ? a : v > b ? b : v);
  const lerp = (a, b, t) => a + (b - a) * t;
  const smooth = (t) => t * t * (3 - 2 * t);
  const eOutCubic = (t) => 1 - Math.pow(1 - t, 3);
  const eOutQuart = (t) => 1 - Math.pow(1 - t, 4);
  const eOutBack = (t) => { const c1 = 1.4, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };
  const PT = new Float32Array(512); for (let i = 0; i < 512; i++) PT[i] = Math.random();
  const noise = (x) => { const i = Math.floor(x), f = x - i, u = f * f * (3 - 2 * f); return (PT[i & 511] * (1 - u) + PT[(i + 1) & 511] * u) * 2 - 1; };

  const vig = $('.sq-vig'), warm = $('.sq-warm'), cd = $('.sq-cd'), cx = cd.getContext('2d');
  let blk = $('.sq-blk'), fx = $('.sq-fx'), fctx = fx.getContext('2d');
  let vw = 0, vh = 0, mobile = false, low = false; const samples = [];
  let CW = 0, CH = 0, FY = 0, cdpr = 1, fdpr = 1, Rb = 1;

  // ── кэштелген геометрия (әр кадрда layout оқымаймыз) ──
  const secs = $$('[data-light]'); let secGeo = [];
  const fq = $('[data-sq-words]'); let fqT = 0, fqH = 1; const words = [];
  const stepEls = $$('.sq-show-steps .sq-step'); let stepGeo = [];
  let heroBottom = 0, docH = 0;
  function measure() {
    const sy = scrollY;
    const h = $('.sq-hero-in'); if (h) heroBottom = h.getBoundingClientRect().bottom + sy;
    secGeo = secs.map((el) => { const r = el.getBoundingClientRect(); return { t: r.top + sy, b: r.bottom + sy, L: +el.getAttribute('data-light') || 1 }; });
    if (fq) { const r = fq.getBoundingClientRect(); fqT = r.top + sy; fqH = Math.max(1, r.height); }
    stepGeo = stepEls.map((el) => el.getBoundingClientRect().top + sy);
    docH = document.documentElement.scrollHeight;
  }
  function pose() {
    const hw = Math.min(vh * 0.11, 92);
    const H = mobile ? { x: vw / 2, y: clamp(heroBottom + 64, vh * 0.7, vh - hw - 26), s: 0.68, w: hw }
                     : { x: vw * 0.75, y: vh * 0.34, s: clamp(vh / 760, 0.85, 1.35), w: vh * 0.36 };
    const D = mobile ? { x: vw / 2, y: vh - 54, s: 0.46, w: 30 } : { x: vw / 2, y: vh - 62, s: 0.54, w: 38 };
    return { H, D };
  }
  let started = false, introDone = false;
  function resize() {
    const w = innerWidth, changedW = (w !== vw); vw = w; vh = innerHeight; mobile = vw < 900;
    const dd = devicePixelRatio || 1; cdpr = Math.min(dd, low ? 1 : (mobile ? 1.5 : 2)); fdpr = Math.min(dd, mobile ? 1.25 : 1.5);
    measure();
    const P = pose().H;
    FY = mobile ? 150 : 220; CW = mobile ? 200 : 280; CH = Math.round(FY + 9 * P.s + P.w + 36);
    cd.width = Math.round(CW * cdpr); cd.height = Math.round(CH * cdpr); cd.style.width = CW + 'px'; cd.style.height = CH + 'px';
    if (fx) { fx.width = Math.round(vw * fdpr); fx.height = Math.round(vh * fdpr); fx.style.width = vw + 'px'; fx.style.height = vh + 'px'; }
    Rb = Math.max(vw, vh) * (mobile ? 1.08 : 0.95);
    if (changedW && started && !introDone) skipIntro();
  }
  on(window, 'resize', resize);
  on(window, 'load', measure);
  let ro = null;
  if ('ResizeObserver' in window) { ro = new ResizeObserver(() => measure()); ro.observe(root); }

  const sprite = (r, rgb) => { const c = document.createElement('canvas'); c.width = c.height = r * 2; const g = c.getContext('2d');
    const gr = g.createRadialGradient(r, r, 0, r, r, r); gr.addColorStop(0, `rgba(${rgb},1)`); gr.addColorStop(0.3, `rgba(${rgb},.55)`); gr.addColorStop(1, `rgba(${rgb},0)`);
    g.fillStyle = gr; g.fillRect(0, 0, r * 2, r * 2); return c; };
  const SPN = sprite(12, '255,205,130'), SPD = sprite(12, '150,92,30'), EMB = sprite(12, '255,150,70');

  // ── кіріспе: ұшқындар Алтынсарин сөзіне айналады (тек бірінші кіргенде) ──
  let t0 = 0, landT = 0, settleT = 0, headT = 0, parts = [];
  const embers = [];
  let wind = 0, pWind = 0, lastSy = scrollY, lightF = 1, flare = 1, flareT = 1, lastPx = null, lastPt = 0;
  let seen = false; try { seen = localStorage.getItem(INTRO_KEY) === '1'; } catch (_) {}
  const markSeen = () => { try { localStorage.setItem(INTRO_KEY, '1'); } catch (_) {} };
  function buildTargets() {
    if (!(vw > 0 && vh > 0)) return [];   // бет әлі өлшенбеген (жасырын қойынды) → getImageData құлайды
    const pts = []; const oc = document.createElement('canvas'); oc.width = vw; oc.height = vh; const g = oc.getContext('2d');
    g.fillStyle = '#fff';
    $$('[data-sq-q] .sq-ql').forEach((sp) => { const r = sp.getBoundingClientRect(), cs = getComputedStyle(sp);
      g.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily; g.textBaseline = 'alphabetic';
      const m = g.measureText(sp.textContent); const asc = m.fontBoundingBoxAscent || m.actualBoundingBoxAscent, des = m.fontBoundingBoxDescent || m.actualBoundingBoxDescent;
      g.fillText(sp.textContent, r.left, r.top + (r.height - (asc + des)) / 2 + asc); });
    const d = g.getImageData(0, 0, vw, vh).data, step = mobile ? 2 : 3;
    for (let y = 0; y < vh; y += step) for (let x = 0; x < vw; x += step) if (d[(y * vw + x) * 4 + 3] > 120) pts.push([x + (Math.random() - 0.5) * step * 0.6, y + (Math.random() - 0.5) * step * 0.6]);
    const cap = mobile ? (cores <= 4 ? 420 : 750) : 1900;
    for (let i = pts.length - 1; i > 0; i--) { const j = Math.random() * (i + 1) | 0; const tmp = pts[i]; pts[i] = pts[j]; pts[j] = tmp; }
    return pts.slice(0, cap);
  }
  function startIntro() {
    started = true; t0 = performance.now();
    if (reduce) { skipIntro(); return; }
    if (seen) { t0 = performance.now() - 700; root.classList.add('sq-q-on', 'sq-h-on', 'sq-nav-on'); return; }
    const P = pose().H, sx0 = P.x, sy0 = P.y - 66 * P.s;
    const pts = buildTargets(); let minX = 1e9, maxX = -1e9; pts.forEach((p) => { if (p[0] < minX) minX = p[0]; if (p[0] > maxX) maxX = p[0]; });
    const span = Math.max(1, maxX - minX); let maxEnd = 0;
    parts = pts.map((p) => {
      const delay = 1350 + (p[0] - minX) / span * 900 + Math.random() * 380, dur = 1000 + Math.random() * 650;
      const sx = sx0 + (Math.random() - 0.5) * 10, sy = sy0 + (Math.random() - 0.5) * 8;
      const my = Math.min(sy, p[1]) - (80 + Math.random() * 220), mx = (sx + p[0]) / 2 + (Math.random() - 0.5) * 260;
      if (delay + dur > maxEnd) maxEnd = delay + dur;
      return { sx, sy, cx: mx, cy: my, tx: p[0], ty: p[1], d: delay, u: dur, z: 0.7 + Math.random() * 0.8, ph: Math.random() * 6.28 };
    });
    landT = maxEnd + 120;
  }
  function skipIntro() { markSeen(); introDone = true; parts = []; t0 = performance.now() - 20000; root.classList.add('sq-q-on', 'sq-h-on', 'sq-nav-on'); }
  ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach((ev) => on(window, ev, () => { if (started && !introDone) skipIntro(); }, { passive: true }));

  // ── жел мен лап ету ──
  if (!touch) on(window, 'pointermove', (e) => { const now = performance.now(); if (lastPx !== null) { const dt = Math.max(8, now - lastPt); pWind += clamp(-(e.clientX - lastPx) / dt * 0.5, -1.2, 1.2) * 0.35; } lastPx = e.clientX; lastPt = now; }, { passive: true });
  let curS = 1, curH = 0;
  const spawnEmber = (fast) => embers.push({ x: CW / 2 + (Math.random() - 0.5) * 8 * curS, y: FY - curH * 0.8, vx: (Math.random() - 0.5) * (fast ? 60 : 20), vy: -(fast ? 90 : 40) - Math.random() * 50, a: 0, l: 1.4 + Math.random() * 1.8, z: 0.35 + Math.random() * 0.55 });
  $$('[data-flare]').forEach((b) => {
    on(b, 'pointerenter', () => { flareT = 1.65; if (!reduce) for (let i = 0; i < 10; i++) spawnEmber(true); });
    on(b, 'pointerleave', () => { flareT = 1; });
    on(b, 'focus', () => { flareT = 1.65; }); on(b, 'blur', () => { flareT = 1; });
  });

  // ── сөздер / санауыштар / көріну ──
  if (fq) { const txt = fq.textContent.trim().split(/\s+/); fq.textContent = ''; txt.forEach((w, i) => { const sp = document.createElement('span'); sp.className = 'sq-w'; sp.textContent = w; fq.appendChild(sp); if (i < txt.length - 1) fq.appendChild(document.createTextNode(' ')); words.push(sp); }); }
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return; const el = e.target; el.classList.add('sq-in'); io.unobserve(el);
    if (!reduce) el.querySelectorAll('[data-sq-count]').forEach((c) => { const to = +c.getAttribute('data-sq-count'); if (!to) return; const st = performance.now();
      (function tick(now) { const k = clamp((now - st) / 1800); c.textContent = nf(to * eOutQuart(k)); if (k < 1) requestAnimationFrame(tick); })(st); });
  }), { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  $$('.sq-rv').forEach((el) => io.observe(el));

  // ── шам (кішкентай canvas, жергілікті координат) ──
  function flamePath(g, x, y, w, h, lean) { g.beginPath(); g.moveTo(x, y + w * 0.42);
    g.bezierCurveTo(x - w * 0.8, y + w * 0.3, x - w * 0.62 + lean * 0.2, y - h * 0.42, x + lean, y - h);
    g.bezierCurveTo(x + w * 0.62 + lean * 0.2, y - h * 0.42, x + w * 0.8, y + w * 0.3, x, y + w * 0.42); g.closePath(); }
  function roundTop(g, x, y, w, h, r) { g.beginPath(); g.moveTo(x, y + h); g.lineTo(x, y + r); g.quadraticCurveTo(x, y, x + r, y); g.lineTo(x + w - r, y); g.quadraticCurveTo(x + w, y, x + w, y + r); g.lineTo(x + w, y + h); g.closePath(); }
  function drawCandle(g, s, waxH, fh, fw, lean, I, lightIn, day, dt) {
    if (!(CW > 0) || ![s, waxH, fh, fw, lean, FY].every(Number.isFinite)) return;   // өлшем дайын емес → createRadialGradient NaN-ға құлайды
    const x = CW / 2, y = FY;
    g.setTransform(cdpr, 0, 0, cdpr, 0, 0); g.clearRect(0, 0, CW, CH);
    const ww = 74 * s, top = y + 9 * s;
    g.globalAlpha = 0.18 + 0.82 * lightIn;
    const sh = g.createRadialGradient(x, top + waxH, 0, x, top + waxH, ww * 0.9); sh.addColorStop(0, day ? 'rgba(70,45,15,.35)' : 'rgba(0,0,0,.6)'); sh.addColorStop(1, 'rgba(0,0,0,0)');
    g.save(); g.translate(x, top + waxH); g.scale(1, 0.2); g.fillStyle = sh; g.fillRect(-ww, -ww, ww * 2, ww * 2); g.restore();
    const wg = g.createLinearGradient(x - ww / 2, 0, x + ww / 2, 0);
    wg.addColorStop(0, day ? '#8C6A40' : '#5E452A'); wg.addColorStop(0.18, '#B69666'); wg.addColorStop(0.42, '#E4CEA4'); wg.addColorStop(0.53, '#F1E3C6'); wg.addColorStop(0.74, '#CDB083'); wg.addColorStop(1, day ? '#86633A' : '#5A4027');
    roundTop(g, x - ww / 2, top, ww, waxH, 6 * s); g.fillStyle = wg; g.fill();
    const lg = g.createLinearGradient(0, top, 0, top + waxH * 0.55); lg.addColorStop(0, 'rgba(255,196,120,' + (0.34 * Math.min(I, 1.8)) + ')'); lg.addColorStop(1, 'rgba(255,196,120,0)');
    g.fillStyle = lg; g.fill();
    g.beginPath(); g.ellipse(x, top + 1, ww / 2, 4.5 * s, 0, 0, Math.PI * 2);
    const tp = g.createRadialGradient(x, top, 0, x, top, ww / 2); tp.addColorStop(0, '#FFF1D0'); tp.addColorStop(0.6, '#EBD3A6'); tp.addColorStop(1, '#C4A171'); g.fillStyle = tp; g.fill();
    g.globalAlpha = 1;
    g.strokeStyle = '#1B120A'; g.lineWidth = 2.4 * s; g.lineCap = 'round';
    g.beginPath(); g.moveTo(x, top + 1); g.quadraticCurveTo(x, y + 3 * s, x + lean * 0.12, y - 2 * s); g.stroke();
    if (fh > 0.5) {
      g.globalCompositeOperation = day ? 'source-over' : 'lighter';
      const hr = Math.min(fh * 1.9, CW / 2), hy = y - fh * 0.45, hg = g.createRadialGradient(x + lean * 0.3, hy, 0, x + lean * 0.3, hy, hr);
      hg.addColorStop(0, 'rgba(255,175,85,' + (day ? 0.22 : 0.30) * Math.min(I, 1.7) + ')'); hg.addColorStop(1, 'rgba(255,175,85,0)');
      g.fillStyle = hg; g.fillRect(x - hr, hy - hr, hr * 2, hr * 2);
      if (!day) { const bb = g.createRadialGradient(x, y + fw * 0.22, 0, x, y + fw * 0.22, fw * 0.5); bb.addColorStop(0, 'rgba(110,140,255,.38)'); bb.addColorStop(1, 'rgba(110,140,255,0)'); g.fillStyle = bb; g.fillRect(x - fw, y - fw * 0.5, fw * 2, fw * 1.5); }
      g.globalCompositeOperation = 'source-over';
      flamePath(g, x, y, fw * 1.18, fh * 1.06, lean * 1.05);
      const og = g.createRadialGradient(x + lean * 0.15, y - fh * 0.12, 0, x + lean * 0.15, y - fh * 0.12, fh); og.addColorStop(0, 'rgba(255,190,90,.35)'); og.addColorStop(1, 'rgba(230,90,30,0)'); g.fillStyle = og; g.fill();
      flamePath(g, x, y, fw, fh, lean);
      const bg = g.createRadialGradient(x + lean * 0.15, y - fh * 0.12, 0, x + lean * 0.15, y - fh * 0.12, fh * 0.96);
      bg.addColorStop(0, 'rgba(255,253,244,1)'); bg.addColorStop(0.22, 'rgba(255,238,186,.98)'); bg.addColorStop(0.5, 'rgba(255,184,86,.92)'); bg.addColorStop(0.78, 'rgba(236,112,40,.55)'); bg.addColorStop(1, 'rgba(200,60,20,0)');
      g.fillStyle = bg; g.fill();
      flamePath(g, x, y + fw * 0.05, fw * 0.5, fh * 0.52, lean * 0.55);
      const cg = g.createRadialGradient(x, y - fh * 0.1, 0, x, y - fh * 0.1, fh * 0.5); cg.addColorStop(0, 'rgba(255,255,252,.95)'); cg.addColorStop(1, 'rgba(255,246,214,0)'); g.fillStyle = cg; g.fill();
    }
    g.globalCompositeOperation = day ? 'source-over' : 'lighter';
    for (let j = embers.length - 1; j >= 0; j--) { const e = embers[j]; e.a += dt; if (e.a > e.l || e.y < 4) { embers.splice(j, 1); continue; }
      e.vx += noise(e.a * 2 + j) * 18 * dt; e.vy -= 6 * dt; e.x += e.vx * dt; e.y += e.vy * dt;
      const al = Math.sin(Math.PI * e.a / e.l) * 0.9 * clamp(e.y / 50), sz = 12 * e.z * (1 - e.a / e.l * 0.5);
      g.globalAlpha = al; g.drawImage(day ? SPD : EMB, e.x - sz / 2, e.y - sz / 2, sz, sz); }
    g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
  }

  // ── өнім көрінісі: телефон экрандары ──
  const phone = $('#sqPhone'); let curStep = -1;
  $$('.sq-pslot').forEach((sl) => { sl.innerHTML = phoneHTML(''); sl.firstElementChild.setAttribute('data-on', sl.getAttribute('data-screen')); });
  const runPages = (scope) => scope.querySelectorAll('[data-sq-pages]').forEach((el) => { if (reduce) { el.textContent = '49'; return; } const st = performance.now();
    (function tick(now) { const k = clamp((now - st) / 1300); el.textContent = Math.round(32 + 17 * eOutCubic(k)); if (k < 1) requestAnimationFrame(tick); })(st); });
  const setStep = (i) => { if (i === curStep || !phone) return; curStep = i; phone.setAttribute('data-on', i); stepEls.forEach((s, j) => s.classList.toggle('sq-act', j === i)); if (i === 1) runPages(phone); };
  let remain = 18 * 60 + 42; const timers = $$('[data-sq-timer]'), rings = $$('.sq-rp');
  const tickTimer = () => { const t = Math.floor(remain / 60) + ':' + String(remain % 60).padStart(2, '0'), off = (565.5 * (1 - remain / 1500)).toFixed(1);
    timers.forEach((el) => { el.textContent = t; }); rings.forEach((el) => el.style.setProperty('--off', off)); };
  tickTimer();
  const timerId = setInterval(() => { if (document.hidden || !running) return; remain = remain > 0 ? remain - 1 : 25 * 60; tickTimer(); }, 1000);
  const pio = new IntersectionObserver((es) => es.forEach((e) => { const el = e.target; el.classList.toggle('sq-off', !e.isIntersecting);
    if (e.isIntersecting && el.getAttribute('data-screen') === '1') runPages(el); }), { threshold: 0.15 });
  $$('.sq-pslot').forEach((sl) => pio.observe(sl));
  const sp = $('.sq-show-phone'); if (sp) pio.observe(sp);
  setStep(0);

  // ── бөлме: 282 КБ H.264 видео (бұрын 2 МБ webp) — тек экранда көрінгенде ойнайды ──
  const roomVid = $('.sq-room video');
  let rio = null;
  if (roomVid && !reduce) {
    rio = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting && running) { const p = roomVid.play(); if (p && p.catch) p.catch(() => {}); } else roomVid.pause();
    }), { threshold: 0.25 });
    rio.observe(roomVid);
  }

  // ── тірі санауыш ──
  fetch('/api/sessions/hearth', { credentials: 'same-origin' }).then((r) => r.json()).then((d) => {
    const el = $('[data-sq-live]'); if (!el || !d) return;
    if (d.active_count >= 3) el.textContent = 'Қазір ' + d.active_count + ' адам оқып отыр';
    else if (d.today_readers) el.textContent = 'Бүгін ' + d.today_readers + ' адам шам жақты';
  }).catch(() => {});

  on($('[data-sq-replay]'), 'click', () => { try { localStorage.removeItem(INTRO_KEY); } catch (_) {} if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; scrollTo(0, 0); location.reload(); });

  // ── кадр ──
  let last = performance.now(), prevWord = -1, running = true, raf = 0;
  function frame(now) {
    if (!root.isConnected) { stop(); return; }
    if (page.style.display === 'none') { running = false; raf = 0; if (roomVid) roomVid.pause(); return; }
    const dt = Math.min(0.05, (now - last) / 1000); last = now; const t = now / 1000, day = isDay(), el = now - t0;
    if (introDone && !low && samples.length < 120 && !document.hidden) { samples.push(dt); if (samples.length === 120) { const av = samples.reduce((a, b) => a + b, 0) / 120; if (av > 0.024) { low = true; resize(); } } }
    const ign = introDone ? 1 : started ? eOutBack(clamp((el - 450) / 900)) : 0;
    const lightIn = introDone ? 1 : started ? smooth(clamp((el - 500) / 1800)) : 0;
    if (started && !introDone) {
      if (el > landT && !settleT) { settleT = now; root.classList.add('sq-q-on'); }
      if (settleT && now - settleT > 450 && !headT) { headT = now; root.classList.add('sq-h-on', 'sq-nav-on'); }
      if (headT && now - headT > 2400) { introDone = true; parts = []; markSeen(); }
    }
    const sy = scrollY, maxS = Math.max(1, docH - vh), PS = pose(), k = smooth(clamp(sy / (vh * 0.85)));
    const x = lerp(PS.H.x, PS.D.x, k), y = lerp(PS.H.y, PS.D.y, k), s = lerp(PS.H.s, PS.D.s, k);
    const waxH = lerp(PS.H.w, PS.D.w, k) * (1 - 0.5 * clamp(sy / maxS));
    const v = sy - lastSy; lastSy = sy; pWind *= 0.9;
    wind += (clamp(v * 0.045 + pWind, -1.3, 1.3) - wind) * 0.07;
    const mid = sy + vh * 0.5; let lightT = 1; for (let i = 0; i < secGeo.length; i++) { if (secGeo[i].t <= mid && secGeo[i].b >= mid) { lightT = secGeo[i].L; break; } }
    lightF += (lightT - lightF) * 0.035; flare += (flareT - flare) * 0.08;
    const wob = reduce ? 0 : 1, I = ign * flare * (1 + 0.035 * noise(t * 5.3) * wob);
    const fh = 66 * s * Math.max(0, I) * (1 + (0.07 * noise(t * 2.3) + 0.04 * noise(t * 6.1)) * wob);
    const fw = 21 * s * (0.86 + 0.14 * Math.min(Math.max(I, 0), 1.7)) * (1 + 0.05 * noise(t * 3.3 + 7) * wob);
    const lean = (wind * 0.95 + 0.1 * noise(t * 1.7 + 3) * wob) * fw;
    curS = s; curH = fh;

    const lcx = x + lean * 0.3, lcy = y - fh * 0.45, ks = lightF * (0.25 + 0.75 * lightIn) * (1 + 0.012 * noise(t * 4.2) * wob);
    const vs = ks * 2 * Rb / 512;
    vig.style.transform = 'translate3d(' + (lcx - 256).toFixed(1) + 'px,' + (lcy - 256).toFixed(1) + 'px,0) scale(' + vs.toFixed(4) + ',' + (vs * (mobile ? 1.25 : 0.85)).toFixed(4) + ')';
    const wk = Math.max(0.001, Math.min(I, 2) * lightF * lightIn * 0.9);
    warm.style.transform = 'translate3d(' + (lcx - 128).toFixed(1) + 'px,' + (lcy - 128).toFixed(1) + 'px,0) scale(' + (wk * Rb / 256).toFixed(4) + ')';
    if (blk) { if (lightIn < 1) blk.style.opacity = (1 - lightIn).toFixed(3); else { blk.remove(); blk = null; } }

    cd.style.transform = 'translate3d(' + (x - CW / 2).toFixed(1) + 'px,' + (y - FY).toFixed(1) + 'px,0)';
    if (!reduce && !low && ign > 0.9 && Math.random() < dt * (day ? 0.7 : 1.5) * (flare > 1.2 ? 5 : 1) * (mobile ? 0.5 : 1)) spawnEmber(false);
    drawCandle(cx, s, waxH, fh, fw, lean, I, lightIn, day, dt);

    if (fx) {
      if (parts.length) {
        fctx.setTransform(fdpr, 0, 0, fdpr, 0, 0); fctx.clearRect(0, 0, vw, vh);
        fctx.globalCompositeOperation = day ? 'source-over' : 'lighter';
        const fade = settleT ? 1 - clamp((now - settleT) / 900) : 1, img = day ? SPD : SPN;
        for (let p = 0; p < parts.length; p++) { const q = parts[p]; if (el < q.d) continue;
          const u = clamp((el - q.d) / q.u), e2 = eOutQuart(u), m = 1 - e2;
          let px = m * m * q.sx + 2 * m * e2 * q.cx + e2 * e2 * q.tx, py = m * m * q.sy + 2 * m * e2 * q.cy + e2 * e2 * q.ty;
          if (u >= 1) { px += Math.sin(t * 3 + q.ph) * 0.4; py += Math.cos(t * 2.6 + q.ph) * 0.4; }
          const sz = (u < 1 ? 10 : 6.5) * q.z; fctx.globalAlpha = fade * (u < 1 ? 0.55 + 0.45 * u : 0.9); fctx.drawImage(img, px - sz / 2, py - sz / 2, sz, sz); }
        fctx.globalAlpha = 1; fctx.globalCompositeOperation = 'source-over';
      } else if (introDone) { fx.remove(); fx = null; }
    }

    if (words.length) { const n = Math.round(clamp((vh * 0.8 - (fqT - sy)) / (fqH + vh * 0.3)) * words.length);
      if (n !== prevWord) { prevWord = n; for (let w = 0; w < words.length; w++) { const onW = w < n; if (words[w]._on !== onW) { words[w]._on = onW; words[w].classList.toggle('sq-won', onW); }
        const hot = (w === n - 1 && n < words.length); if (words[w]._hot !== hot) { words[w]._hot = hot; words[w].classList.toggle('sq-hot', hot); } } } }
    if (!mobile && stepGeo.length) { let best = 0; for (let i = 0; i < stepGeo.length; i++) { if (stepGeo[i] - sy < vh * 0.55) best = i; } setStep(best); }

    raf = requestAnimationFrame(frame);
  }
  function stop() {
    running = false; if (raf) cancelAnimationFrame(raf); raf = 0;
    offs.forEach((f) => f()); offs.length = 0; clearInterval(timerId);
    io.disconnect(); pio.disconnect(); if (rio) rio.disconnect(); if (ro) ro.disconnect(); if (mo) mo.disconnect();
  }
  // Бет қайта көрсетілсе (мысалы, қонақ режимінен қайтқанда) — цикл жалғасады.
  const mo = new MutationObserver(() => {
    if (!root.isConnected) { stop(); return; }
    if (!running && page.style.display !== 'none') { running = true; last = performance.now(); measure(); raf = requestAnimationFrame(frame); }
  });
  mo.observe(page, { attributes: true, attributeFilter: ['style'] });

  resize();
  if (reduce) words.forEach((w) => w.classList.add('sq-won'));
  const fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
  Promise.race([fontsReady, new Promise((r) => setTimeout(r, 1800))]).then(() => {
    if (!root.isConnected) return;
    measure();
    if (scrollY > 40) { started = true; skipIntro(); } else startIntro();
  });
  raf = requestAnimationFrame(frame);
}
